import type { C2pSectorOverride } from '@/utils/flights/c2p/sectors'

export const CHECKOUT_FLOW_ENABLED_HEADER = 'CHECKOUT_FLOW_ENABLED'
export const CHECKOUT_FLOW_ENABLED_COOKIE = 'CHECKOUT_FLOW_ENABLED'


export const isCheckoutFlowEnabled = (override?: C2pSectorOverride): boolean => true

export const applyCheckoutFlowHeader = (
    headers: Record<string, any>,
    override?: C2pSectorOverride
): void => {
    if (isCheckoutFlowEnabled(override)) {
        headers[CHECKOUT_FLOW_ENABLED_HEADER] = 'true'
    }
}
